import { capitalizeName } from "helper/appConstant";
import { useState } from "react";

const SelectField = ({
  options,
  value,
  onChange,
  id,
  error,
  isRequired,
  placeholder,
  isNoPlaceHolder,
  label,
  isSport,
  isKeyMemberRole, //  this show the select field is for key member role
}) => {
  const [focusedInput, setFocusedInput] = useState(false);

  return (
    <>
      <div className="relative group">
        {label && (
          <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
            {label}
            {isRequired && (
              <span className="text-red-500 ml-1 font-bold">*</span>
            )}
          </label>
        )}

        <div className="relative pt-1">
          <select
            id={id}
            value={value || ""}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onFocus={() => setFocusedInput(true)}
            onBlur={() => setFocusedInput(false)}
            className={`w-full border-2 text-sm ${
              focusedInput
                ? "border-[#2BACE2] shadow-lg shadow-blue-100"
                : "border-gray-200"
            } rounded-lg pl-2 pr-10 py-3 bg-white focus-visible:outline-none transition-all appearance-none`}
          >
            {/* Placeholder option */}
            {!isNoPlaceHolder && (
              <option
                value=""
                disabled
                selected={!value}
                className="text-gray-400"
              >
                {placeholder}
              </option>
            )}
            {options?.map((option, index) => (
              <option
                key={index}
                value={
                  isSport ? option?.name : option?.id ? option?.id : option
                }
                selected={
                  isSport
                    ? value === option?.name
                    : option?.id
                    ? value === option?.id
                    : value === options
                }
                disabled={option?.disable}
              >
                {isSport
                  ? option?.name
                  : isKeyMemberRole
                  ? capitalizeName(option?.roleName)
                  : option?.id
                  ? option?.name
                  : option}
              </option>
            ))}
          </select>

          {/* Down Arrow Icon */}
          <div className="absolute top-0 right-0 flex items-center h-full pr-4 pointer-events-none">
            <svg
              className="w-5 h-5 text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      </div>
      {error && (
        <div className="text-red-400 font-semibold text-sm">{error}</div>
      )}
    </>
  );
};

export default SelectField;
